<template>
<div>
  <p><b>Public Data Policy Expanded</b></p>
  <p>Beginning February 1st 2024, all science data in the archive will be publicly available after the
proprietary period for that data has ended. Therefore, all partner data with the 12 month
default proprietary period will start becoming publicly available on February 1st 2025.
Although this policy has been in place for INAF data since 2010, the policy is now expanded to
include all partner science data.</p>
</div>
</template>

<script>
export default {
  methods: {
    openModalByRef(ref) {
      this.$root.$refs.helpSidebar.openModalByRef(ref);
    }
  }
}
</script>

